import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import { ModulesProvider } from './context/ModulesContext';
import { Toaster } from './components/ui/sonner';
import { InstallPWA } from './components/InstallPWA';
import { AppRoutes } from './routes/AppRoutes';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <ModulesProvider>
            <BrowserRouter>
              <div className="App">
                <AppRoutes />
                <Toaster position="top-center" richColors />
                <InstallPWA />
              </div>
            </BrowserRouter>
          </ModulesProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
